import { Injectable, Injector } from '@angular/core';
import { defaultToastConfig, ToastConfig, ToastData } from '../toasts/config/toast.config';
import { ToastRef } from '../toasts/config/toast.ref';
import { Overlay } from '@angular/cdk/overlay';
import { ComponentPortal, PortalInjector } from '@angular/cdk/portal';
import { FullWidthToastComponent } from '../toasts/full-width-toast/full-width-toast.component';


@Injectable({
  providedIn: 'root'
})
export class ToastService {

  private lastToast: ToastRef;
  toastConfig: ToastConfig = defaultToastConfig;

  constructor(
    private overlay: Overlay,
    private parentInjector: Injector
  ) { }

  internalShow(data: ToastData) {
    const positionStrategy = this.getPositionStrategy();
    const overlayRef = this.overlay.create({ positionStrategy });
    const toastRef = new ToastRef(overlayRef);
    this.lastToast = toastRef;
    const injector = this.getInjector(data, toastRef, this.parentInjector);
    const toastPortal = new ComponentPortal(FullWidthToastComponent, null, injector);
    overlayRef.attach(toastPortal);
    return toastRef;
  }

  show(data: ToastData) {
	// due to animate used in diplaying message calculation is not correct
	setTimeout(() => this.internalShow(data), 400);
  }

  getPositionStrategy() {
    return this.overlay.position()
      .global()
      .top(this.getPosition())
      .right(this.toastConfig.position.right + 'px');
  }

  getPosition() {
    const lastToastIsVisible = this.lastToast && this.lastToast.isVisible();
    const position = lastToastIsVisible
      ? this.lastToast.getPosition().bottom
      : this.toastConfig.position.top;
    return position + 'px';
  }

  getInjector(data: ToastData, toastRef: ToastRef, parentInjector: Injector) {
    const tokens = new WeakMap();
    tokens.set(ToastData, data);
    tokens.set(ToastRef, toastRef);
    return new PortalInjector(parentInjector, tokens);
  }
}
